const capitalizeFirstName = (firstName?: string) => {
  if (!firstName || firstName.length === 1) {
    return firstName
  }
  return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase()
}

export default capitalizeFirstName
